import { render, staticRenderFns } from "./SearchPsychologist.vue?vue&type=template&id=3c15b33e&"
import script from "./SearchPsychologist.vue?vue&type=script&lang=ts&"
export * from "./SearchPsychologist.vue?vue&type=script&lang=ts&"
import style0 from "./SearchPsychologist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports